import { TranslationMessages } from 'react-admin';
import messages from 'paperman-translations';
import frenchMessages from 'ra-language-french';

const customFrenchMessages: TranslationMessages = {
  ...frenchMessages,
  ...messages['fr'],
};

export default customFrenchMessages;
